

import { ref, reactive, watch, onBeforeMount, computed, onMounted, onUnmounted } from 'vue';
import Button from '@/components/ui/button/index.vue';
import Table from '@/components/ui/tablebox/index.vue';
import Tab from '@/components/ui/tab/index.vue';
import TableInfo from '@/components/ui/tableinfo/index.vue';
import Select from '@/components/ui/select/index.vue';
import CTmenu from '@/components/ui/ctmenu/index.vue';
import Input from '@/components/ui/input/index.vue';
import Pagination from '@/components/ui/pagination/index.vue';
import FlashMsg from '@/components/ui/flashMsg/index.vue';
import Radio from '../../../components/ui/radio/index.vue';
import DatePickerLocal from '@/components/ui/datePicker/index.vue';
import multiSelect from '@/components/ui/multiselect/index.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { ERRORDESC, ACTIONBAR, POPUP, CONNECTION, TASKTAB, REPEAT_TYPE, USERMODE, BRIGHTNESSUNIT, BRIGHTNESSMAX, UNIT } from '../../../enum/enum';
import { useStore } from 'vuex';
import { dateTimeHandle } from '@/utils/time';
import * as moment from 'moment';
import { colorGamutHandler, gamutCustomHandler } from '@/utils/attribute';

import {  apiSettings, apiDeleteTask, apiTaskGetAP, apiDeleteAppointment, apiGetGroupModel, apiETTasksList, apiGetAppointmentTask} from '@/api/api';

export default {
  name: 'devicedetail',
  components: {
    Button,
    Radio,
    Tab,
    Select,
    Table,
    TableInfo,
    CTmenu,
    Pagination,
    Input,
    FlashMsg,
    DatePickerLocal,
    multiSelect
  },
  props: {

  },
  setup() {
    const { t } = useI18n();



    const route = useRouter()
    // const fatherLink = route.currentRoute.value.fullPath


    const state = reactive({
      //filter 選單內容
      // implementDate: [new Date(2019, 9, 8), new Date(2022, 10, 10)], 
      emptyStatus: {
        text: t('__t4.__noSelect'),
        val: 'default',
        isI18n: '__t4.__noSelect',
      },
      implementDate: [],
      selectImStatus: [],
      imStatusOption: [
        {
          text: t('__common.__success'),
          val: '1',
          group: 'status',
          isI18n: '__common.__success',
        },
        {
          text: t('__common.__fail'),
          val: '0',
          group: 'status',
          isI18n: '__common.__fail',
        },
        {
          text: t('__d7d_n17r.__waitingForReply'),
          val: '2',
          group: 'status',
          isI18n: '__d7d_n17r.__waitingForReply',
        }
      ],
      selectModel: [],
      modelOption: [],
      selectGroup: [],
      groupOption: [],
      executedDateType: '0',//radio 
      //頁碼
      meta: {
        total_page: 0,
        current: 1,
        per_page: 12,
      },
      isTabShow: ACTIONBAR.VIEWHIS,
      appListData: [],
      exeListData: [],
      order: 'desc',
      sort: '',
      preset: [], //appointment mapping，預設值列表
      calibrators: [], //Calibrator Type
      colorRange: [], //setting傳回來的資料
      eotf: [], // eotf列表
      gamut: [], // gamut列表
      list: [],//打勾的列表
      applyDisable: true,
      rawData: {},
      tableETDisableList: [],
      tableAPDisableList: [],
      defaultCheckIndexList: [], //default check list execute task & appointemtnt
      modalStatusList: [], //satus 的 popup 的device清單

    })

    const deviceDetailPage = ref();

    onBeforeMount(async () => {

      let a = route.currentRoute.value.params.tabId;
      state.isTabShow = `${a}`;
      timeInit()
      await pageSettingInit()
      await queryModels();
      await getSetting();
      await apiPost();
    })

    let interval = null;
    onMounted(() => {  //確認一下這頁是不是也需要不斷更新資料

      // interval = setInterval(() => {
      //   if (state.isTabShow === TASKTAB.EXECUTED || state.isTabShow === TASKTAB.APPOINTMENT) {
      //     apiPost(false);
      //   }
      // }, storeState.updateTime);
    })

    watch(
      () => route,
      (to) => {
        let a = to.currentRoute.value.params.tabId
        state.isTabShow = `${a}`;
        pageSettingInit()
        apiPost()
      },
      { deep: true }
    )

    const apiPost = async (isNeedLoading = true) => {
      switch (state.isTabShow) {
        case TASKTAB.EXECUTED:
          await getTasks(isNeedLoading)
          break;
        case TASKTAB.APPOINTMENT:
          await getAPData(isNeedLoading);
          break;
      }
    }

    const pageSettingInit = () => {

      state.meta.current = 0;
      state.meta.total_page = 1;
      state.meta.per_page = 12;
      resetFilterInit()
    }

    const resetFilterInit = () => {
      state.selectGroup = state.groupOption;
      state.selectModel = state.modelOption;
      state.sort = '';
      //時間要重置
      timeInit()
      switch (state.isTabShow) {
        case TASKTAB.EXECUTED:
          state.selectImStatus = state.imStatusOption
          break;
        case TASKTAB.APPOINTMENT:
          state.executedDateType = '0'
          break;
      }
    }


    onUnmounted(() => {
      clearInterval(interval);
    })

    const tabText = computed(() => {
      return [{
        name: t('__d4e_m8t.__executedTasks'),
        val: TASKTAB.EXECUTED,
        disabled: false,
      }, {
        name: t('__g3p_m8t.__appointment'),
        val: TASKTAB.APPOINTMENT,
        disabled: false,
      }]

    })

    const timeInit = () => {
      if(state.isTabShow == TASKTAB.EXECUTED) {
        let defaultStart = moment().format('YYYY, MM, DD')
        let sy = moment().format('YYYY')
        let sm = parseInt(moment().format('M'))
        let sd = moment().format('D')
        let ss = `${sy}, ${sm}, ${sd}`
        let defaultEnd = moment(defaultStart).subtract(6, 'months').format('YYYY, MM, DD');
        let ey = moment(defaultEnd).format('YYYY')
        let em = parseInt(moment(defaultEnd).format('M'))
        let ed = moment(defaultEnd).format('D')
        let es = `${ey}, ${em}, ${ed}`

        state.implementDate[1] = new Date(ss)
        state.implementDate[0] = new Date(es)
      }else{
        state.implementDate = []
      }
    }


    const caulDateTimeStamp = () => {
      let temp = [];
      // let location = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!state.implementDate.length) {
        // timeInit()
        return
      }
      for (let i = 0; i < state.implementDate.length; i++) {
        // temp[i] = moment.tz(state.implementDate[i], location).format();
        temp[i] = state.implementDate[i]
        if(i == 1){
          temp[i] = moment(temp[i]).add(1, 'day');//取到隔日的00:00:00
        }
        temp[i] = moment(temp[i]).format("X");
      }
      for (let i = 0; i < temp.length; i++) {
        temp[i] = parseInt(temp[i]) * 1000; //要傳毫秒要 * 1000
      }
      return temp
    }



    //API start

    const queryModels = async () => {
      state.selectImStatus = state.imStatusOption
      try {
        const datas = await apiGetGroupModel();
        console.log('query all', datas)
        if (!datas.status_code) {
          //model
          let arrModel = [];
          for (let j = 0; j < datas.model.length; j++) {
            arrModel.push({ text: datas.model[j], val: datas.model[j] })
          }
          state.modelOption = arrModel;
          state.selectModel = arrModel;
          //group
          let arrGroup = [];
          arrGroup.push({
            text: t('__t4.__noGroup'),
            val: null,
            isI18n: '__t4.__noGroup',
          })
          for (let j = 0; j < datas.groups.length; j++) {
            arrGroup.push({ text: datas.groups[j].name, val: datas.groups[j].id })
          }
          state.groupOption = arrGroup;
          state.selectGroup = arrGroup;
        }
      }
      catch (error) {
        return error;
      }
    }

    const getSetting = async () => {
      const sendData = {
        model: 'PA32DC', //寫死，取得outline資料做比對
      }
      try {
        const datas = await apiSettings(sendData);
        // console.log('apiSettings', datas)
        state.preset = datas.data.model.preset_modes;
        datas.data.calibrators.forEach((item) => {
          state.calibrators[item.id] = item.name
        })
        state.colorRange = datas.data.color_range
        state.eotf = datas.data.eotf
        state.gamut = datas.data.gamut
      }
      catch (error) {
        return error;
      }
    }

    const clickTasksStatus = async (v , flag) => {
      let id = flag ? v.id : v.val.id
      // const id = v.id
      // console.log('task 的 id :::',id)
      const sendData = {}
      try {
        const datas = await apiETTasksList(id, sendData);
        console.log('apiGetTasks', datas)
        state.modalStatusList = datas.tasks;
        for (let i = 0; i < state.modalStatusList.length; i++) {
          state.modalStatusList[i].newStatus = null
          if (state.modalStatusList[i].deleted) {
            state.modalStatusList[i].newStatus = 4
          } else {
            if( state.modalStatusList[i].status == 0){
              state.modalStatusList[i].newStatus = 999
            }else{
              state.modalStatusList[i].newStatus = state.modalStatusList[i].status
            }
          }
          // console.log('ghtty',state.modalStatusList[i].status,state.modalStatusList[i].newStatus )
        }//depiction_code

        const modalConfig = {
          type: POPUP.IMPLEMENTATION,
          data: {
            col: modalColumn2,
            list: state.modalStatusList,
            id:  flag ? v.id : v.val.id,
            optionModel: state.modelOption,
            optionStatus: opDLList,
            group_name: v.group_name
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)

      }
      catch (error) {
        return error;
      }

    }

    // apiTaskGetAP
    const getTasks = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      let temp = caulDateTimeStamp()
      // console.log('temp', temp)
      // console.log(route.currentRoute.value)
      const bodyData = {
        device_groups: Object.values(state.selectGroup).map(item => item.val).length == state.groupOption.length ? undefined : Object.values(state.selectGroup).map(item => item.val),
        models: Object.values(state.selectModel).map(item => item.val).length == state.modelOption.length ? undefined : Object.values(state.selectModel).map(item => item.val),
        status: Object.values(state.selectImStatus).map(item => item.val).length == state.imStatusOption.length ? undefined : Object.values(state.selectImStatus).map(item => item.val),
      }
      const sendData = {
        page: state.meta.current,
        order: state.order,
        // sort: state.sort ? state.sort : 'action_timestamp',
        sort: state.sort ? state.sort == "newStatus" ? "status" : state.sort : 'action_timestamp',
        per_page: state.meta.per_page,
        time: temp ? 'action_timestamp' : undefined,
        start: temp ? temp[0] : undefined,// 毫秒
        end: temp ? temp[1] : undefined,
      }

      const sendData2 = Object.fromEntries(Object.entries(sendData).filter(([_, v]) => { return _ && v != undefined })); //去除value為null 或空值的key

      // console.log('sendData2', sendData2)
      try {
        const datas = await apiGetAppointmentTask(sendData2, bodyData); //apiTaskGetEX  apiGetAppointmentTask
        console.log('apiGetTasks', datas)
        if (!datas.status_code) {
          let temp = datas.data
          for (let i = 0; i < temp.length; i++) {
            datas.data[i]['newStatus'] = null;
            datas.data[i].action_timestamp = dateTimeHandle(datas.data[i].action_timestamp);
            if (datas.data[i].status == 0 ) {
              datas.data[i]['newStatus'] = 999
            }else if(datas.data[i].status == null){
              // datas.data[i]['newStatus'] = 666;
              datas.data[i]['newStatus'] = `${datas.data[i].success}/${datas.data[i].fail}/${datas.data[i].wait}`;
            }else {
              datas.data[i]['newStatus'] = datas.data[i].status
            }
            if (datas.data[i].color_range != undefined) {
              datas.data[i].color_range = Object.keys(state.colorRange).find(key => state.colorRange[key] === datas.data[i].color_range);  //Dynamic Range	的 enum 從apiSetting來的
            } else {
              datas.data[i].color_range = ''
            }
            datas.data[i].mode2 = datas.data[i].mode
            datas.data[i].mode = USERMODE[datas.data[i].mode]
            if (datas.data[i].group_name) {
              datas.data[i]['groupOrSsn'] = datas.data[i].group_name;
            }else {
              datas.data[i]['groupOrSsn'] = datas.data[i].ssn;
            }
            datas.data[i].implementationStatus = `${datas.data[i].success}/${datas.data[i].fail}/${datas.data[i].wait}`;
          }
          // console.log('Tasks state.exeListData', temp); //exeListCol
          state.exeListData = temp;
          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.rawData = datas;
          console.log('更新的!!!!', state.rawData)

        }
      }
      catch (err) {
        console.log("apiGetTasks", 'err')
      }
    }


    const getAPData = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      let temp = caulDateTimeStamp()
      // console.log('temp', temp)
      const bodyData = {
        groups: Object.values(state.selectGroup).map(item => item.val).length == state.groupOption.length ? undefined : Object.values(state.selectGroup).map(item => item.val),
        models: Object.values(state.selectModel).map(item => item.val).length == state.modelOption.length ? undefined : Object.values(state.selectModel).map(item => item.val),
      }
      const sendData = {
        page: state.meta.current,
        order: state.order,
        sort: state.sort ? state.sort == "repeatCol" ? "repeat" : state.sort : 'updated_at',
        per_page: state.meta.per_page,
        time: temp ? state.executedDateType == '0' ? 'updated_at' : 'next_timestamp' : undefined,
        start: temp ? temp[0] : undefined,// 毫秒
        end: temp ? temp[1] : undefined,
      }

      const sendData2 = Object.fromEntries(Object.entries(sendData).filter(([_, v]) => { return _ && v != undefined })); //去除value為null 或空值的key

      try {
        const datas = await apiTaskGetAP(sendData2, bodyData);
        console.log('api device Appointment', datas)
        if (!datas.status_code) {

          for (let i = 0; i < datas.data.length; i++) {
            if (datas.data[i].updated_at) {
              datas.data[i].updated_at = dateTimeHandle(datas.data[i].updated_at, 'x');
            }
            datas.data[i].repeat_start_date = dateTimeHandle(datas.data[i].repeat_start_date, 'YYYY.MM.DD');
            if (datas.data[i].next_timestamp) {
              datas.data[i].next_timestamp = dateTimeHandle(datas.data[i].next_timestamp, 'x');
            } else {
              datas.data[i].next_timestamp = null;
            }
            datas.data[i].time_zone = datas.data[i].time_zone > 0 ? `+${datas.data[i].time_zone}` : datas.data[i].time_zone
            if (datas.data[i].repeat_start_min || datas.data[i].repeat_start_min == 0) { //給的分鐘數沒有補0，自己補一下
              if (datas.data[i].repeat_start_min.toString().length < 2) {
                datas.data[i].repeat_start_min = `0${datas.data[i].repeat_start_min}`
                // console.log(datas.data[i].repeat_start_min)
              }
            }
            datas.data[i].time = `${datas.data[i].repeat_start_hour}:${datas.data[i].repeat_start_min} (UTC${datas.data[i].time_zone})`

            if (datas.data[i].group_name) {
              datas.data[i]['groupOrSsn'] = datas.data[i].group_name;
            }else {
              datas.data[i]['groupOrSsn'] = datas.data[i].ssn;
            }

            let hasTarget = datas.data[i].preset_target ? Array.isArray(datas.data[i].preset_target) ? datas.data[i].preset_target.length : true : false;
            // console.log('hasTarget', hasTarget)
            if (hasTarget) {
              datas.data[i].secondTitle = 'Calibrator'
              datas.data[i].dataInfo = []
              datas.data[i].dataInfo = presetTarget(datas.data[i].preset_target, datas.data[i].calibrator)
              // console.log(datas.data[i].dataInfo,'dataInfo' )
            }
            else {
              // console.log(i,'index')
              datas.data[i].dataInfo = []
              let col = []
              let data = []
              let obj = { calibrator: state.calibrators[datas.data[i].calibrator] || 'Unknown', ...datas.data[i].custom_settings }
              // console.log(obj,' why no show my obj')
              // console.log(' why no show my obj',datas.data[i].calibrator)
              if (obj['eotf'] && obj['eotf'] == 2) {  //當eotf數值為2的時候會有brightness_min，兩個都要放進brightness裡面 //0421改
                // obj['brightness'] = obj['brightness_min']
                if (obj['brightness']) {
                  let brightness;
                  if (datas.data[i].calibrator == 4 && (obj['brightness'] > 650)) {
                    brightness = isSpecificCalibrator(obj['brightness'])//特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
                  } else {
                    for (const key in BRIGHTNESSMAX) {
                      if (obj['brightness'] == key) {
                        brightness = BRIGHTNESSMAX[key]
                      } else {
                        brightness = ` ${obj['brightness']} ${UNIT.NTM2}`;
                      }
                    }
                  }

                  obj['brightness'] = `${BRIGHTNESSUNIT.lmax} :  ${brightness} <br> ${BRIGHTNESSUNIT.lmin}  : ${obj['brightness_min']} ${UNIT.NTM2}`
                  // console.log(brightness)
                } else {
                  obj['brightness'] = `${BRIGHTNESSUNIT.lmin} : ${obj['brightness_min']} ${UNIT.NTM2}`
                }
              } else {
                if (obj['brightness']) {
                  let brightness;
                  if (datas.data[i].calibrator == 4 && (obj['brightness'] > 650)) {
                    brightness = isSpecificCalibrator(obj['brightness'])//特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
                  } else {
                    for (const key in BRIGHTNESSMAX) {
                      if (obj['brightness'] == key) {
                        brightness = BRIGHTNESSMAX[key]
                      } else {
                        brightness = ` ${obj['brightness']} ${UNIT.NTM2}`;
                      }
                    }
                  }
                  obj['brightness'] = ` ${brightness}`;
                  // obj['brightness'] = ` ${obj['brightness']} ${UNIT.NTM2}`;
                }
              }

              if (obj['color_temperature'] || obj['color_temperature'] == 0) {
                obj['color_temperature'] = obj['color_temperature'] + ' k';
                // console.log(obj['color_temperature'],"obj['color_temperature']")
              }

              //coordinate start
              if (obj['color_x'] && obj['color_y']) {
                obj['coordinate'] = `x : ${obj['color_x']}   y : ${obj['color_y']}`
              }
              //coordinate end

              // console.log('欸欸欸',state.eotf)
              if ((obj['color_range'] || obj['color_range'] == 0) && state.colorRange) {  //mapping apiSetting 的 color_range
                obj['color_range'] = Object.keys(state.colorRange).find(key => state.colorRange[key] === obj['color_range']);  //從value找 key 值......
                // console.log(obj['color_range'],"obj['color_range']")
                if (obj['gamut'] || obj['gamut'] == 0) {
                  // 使用 colorGamutHandler 處理 Gamut 顯示
                  if (obj['gamut'] === 7 && obj['gamut_custom']) {
                    // 當 Gamut = 7 (Custom) 時，顯示 Red(x,y), Green(x,y), Blue(x,y)
                    obj['gamut'] = gamutCustomHandler(obj['gamut_custom']);
                  } else {
                    obj['gamut'] = colorGamutHandler(obj['gamut']);
                  }
                }

                if ((obj['eotf'] || obj['eotf'] === 0)) {  //eotf 有存在
                  if (obj['eotf'] && obj['eotf'] == 1) {  //當eotf數值為1 (Gamma)的時候，Gamma這個欄位要直接被消失，並把原本Gamma內的數值放進eotf中
                    obj['eotf'] = `Gamma ${obj['gamma']}`
                    // console.log(obj['eotf'],obj['gamma'], "obj['eotf']")
                    obj = Object.fromEntries(Object.entries(obj).filter(([key]) => {
                      return key != 'gamma'
                    }));
                  } else {
                    for (const k in state.colorRange) {
                      if (obj['color_range'] == k && state.eotf[k]) {  //照color_range的不同，eotf要mapping的obj不一樣
                        obj['eotf'] = Object.keys(state.eotf[k]).find(key =>   //state.eotf有兩個obj，先根據color_range的key值去找到哪一個obj，再從api 給的eotf的value找 對應的key 值
                          state.eotf[k][key] == obj['eotf']
                        );
                      }
                    }
                  }

                }
              }
              // console.log(obj, "obj整理過的")
              // console.log( "obj整理過的",state.eotf)
              data.push(obj ? obj : ' ')
              // console.log(data,"data obj放進來的")
              let tempCol = Object.fromEntries(Object.entries(obj).filter(([_, v]) => { return _ && v != null })); //去除value為null 或空值的key
              // let tempCol = Object.fromEntries(Object.entries(obj).filter(() => { return true })); //不去除空直了
              // console.log(tempCol, "tempCol")
              col = Object
                .keys(tempCol)
                .filter(key => key && key != 'brightness_min' && key != 'gamma' && key != 'gamut_custom')  //brightness_min, gamma, gamut_custom 不呈現在 th 上面
                .map((e) => {
                  return {
                    'title': e, //原 PRESET_TITLE[e]
                    'key': e
                  }
                })
              // console.log(col, "col")
              datas.data[i].dataInfo.push({ data: data, col: col })
              // console.log(datas.data[i].dataInfo,"datas.data[i].dataInfo")
            }
          }
          setRepeat(datas.data)

          state.meta.current = datas.current_page;
          state.meta.total_page = datas.last_page;
          state.meta.per_page = datas.per_page;
          state.rawData = datas;
          state.appListData = datas.data;

          state.tableAPDisableList = state.appListData.map((e) => {
            return e.group ? true : false; //group有值的話不能刪除
          })
          console.log("col", state.tableAPDisableList)
        }
      }
      catch (error) {
        return error;
      }
    }

    const deleteET = async () => {
      console.log(state.list, 'deleteET')
      let id = []
      id = state.list.map(item => item.id);
      const sendData = {
        id: id,
        appointment: true,
      }
      try {
        const datas = await apiDeleteTask(sendData);
        console.log('apiDeleteTask', datas)
        if (!datas.status_code) {
          apiPost()
          state.list = [];
          state.defaultCheckIndexList = [];
        }
      }
      catch (error) {
        return error;
      }
    }

    const deleteAP = async () => {
      console.log(state.list)
      let id = []
      id = state.list.map(item => item.id);
      const sendData = {
        id: id,
      }
      try {
        const datas = await apiDeleteAppointment(sendData);
        console.log('apiDelete Appointment', datas)
        if (!datas.status_code) {
          apiPost()
          state.list = []
          state.defaultCheckIndexList = [];
        }
      }
      catch (error) {
        return error;
      }
    }






    //API end


    const setAppListColSub = (e) => {
      let temp = []
      // console.log('setAppListColSub',e)
      for (let key in appListColSub.value) {
        for (let i = 0; i < e.length; i++) {
          if (key == e[i].title) {
            temp.push({
              'title': appListColSub.value[key],
              'key': e[i].key
            })
          }
        }

      }
      // console.log(temp)
      return temp
    }

    const isSpecificCalibrator = (val) => { //特殊規格矯正器限制，最高只能固定650，但給user設定的數字要標註在後面
      for (const key in BRIGHTNESSMAX) {
        if (val == key) {
          return `650 (${BRIGHTNESSMAX[key]}) ${UNIT.NTM2}`
        } else {
          return `650 (${val}) ${UNIT.NTM2}`
        }
      }
    }

    const presetTarget = (target, calibrator) => {

      // console.log('target',target)
      let arr = []
      for (let k = 0; k < target.length; k++) {
        let col = []
        let data = []
        let presetData = state.preset[target[k]] || {};
        let obj = { calibrator: state.calibrators[calibrator] || 'Unknown', ...presetData, presetMode: presetData.name || 'Unknown' }

        // 處理 Gamut 顯示
        if (obj['gamut'] || obj['gamut'] === 0) {
          if (obj['gamut'] === 7 && obj['gamut_custom']) {
            obj['gamut'] = gamutCustomHandler(obj['gamut_custom']);
          } else {
            obj['gamut'] = colorGamutHandler(obj['gamut']);
          }
        }

        if (obj['color_range']) {
          if (obj['eotf']) {
            if (state.eotf[obj['color_range']]) {
              let temp = Object.keys(state.eotf[obj['color_range']]).find(key =>  //把Gamma找出來比對
                key == 'Gamma'
              );
              if (temp == obj['eotf']) {
                obj['eotf'] = `${obj['eotf']}  ${obj['gamma']}`
                obj = Object.fromEntries(Object.entries(obj).filter(([key]) => {
                  return key != 'gamma'
                }));
              }
            }
          }
        }
        if (obj['brightness']) {
          obj['brightness'] = `${obj['brightness']} ${UNIT.NTM2}`
        }

        data.push(obj ? obj : ' ')
        // let tempCol = Object.fromEntries(Object.entries(obj).filter(([_, v]) => { return _ && v != null })); //去除value為null 或空值的key
        //[_, v]
        let tempCol = Object.fromEntries(Object.entries(obj).filter(() => { return true }));

        col = Object
          .keys(tempCol) //tempCol
          .filter(key => key && key != 'name' && key != 'id' && key != 'color_range' && key != 'gamma' && key != 'gamut_custom')  //name, id, color_range, gamma, gamut_custom 不呈現在 th 上面
          .map((e) => {
            return {
              'title': e, //原 PRESET_TITLE[e]
              'key': e
            }
          })
        arr.push({ data: data, col: col })
      }
      return arr
    }

    const setRepeat = (v) => {
      v.forEach(e => {
        // console.log('@@@@',e)
        if (e.repeat_cycle) {
          if(REPEAT_TYPE[e.repeat_type] =='week'){

            e.repeatCol = t('__d4e_m8t.__repeatEveryNumWeek',{num : `  ${e.repeat_cycle}`}) ;
          }else{
            e.repeatCol = t('__d4e_m8t.__repeatEveryNumMonth',{num : `  ${e.repeat_cycle}`}) ;
          }
        } else {
          e.repeatCol = 'Single'
        }
      });

    }

    const setRepeatCol = (e) => {
      if (e.repeat_cycle) {
        if(REPEAT_TYPE[e.repeat_type] =='week'){
          return t('__d4e_m8t.__repeatEveryNumWeek',{num : `  ${e.repeat_cycle}`}) ;
        }else{
          return t('__d4e_m8t.__repeatEveryNumMonth',{num : `  ${e.repeat_cycle}`}) ;
        }
      } else {
        return 'Single'
      }
    }

    const modeCol = (data, col) => {
      if(data[col.key] == 1 || data[col.key] == 2){
        return t('__d4e_m8t.__userMode') + ' ' + data[col.key]
      }else if(data[col.key] == 0){
        return t('__d4e_m8t.__presetMode', brand.value)
      }else{
        return '- - -'
      }
    }


    //appointment th 標題欄位們
    const appListCol = computed(() => {
      return [
        {
          title: t('__common.__group') + ' / ' + t('__d7d_n17r.__serialNumber'),
          key: "groupOrSsn",
          isLink: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
          sort: true,
        },
        {
          title: t('__t4.__setDate'),
          key: "updated_at",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__repeat'),
          customRender: "repeatColData",
          key: "repeatCol",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__upcomingCalibrationDate'),
          key: "next_timestamp",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__time'),
          key: "time",
          sort: true,
        },

        {
          title: t('__common.__modify'),
          customRender: "modify", //客製化slot，可用於外接其他組件
          key: "modify",
        },
      ]

    })

    //executed task th 標題欄位們
    const exeListCol = computed(() => {
      // let changeVal = 
      return [
        {
          title: t('__common.__group') + ' / ' + t('__d7d_n17r.__serialNumber'),
          key: "groupOrSsn",
          isLink: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__implementDate'),
          key: "action_timestamp",
          sort: true,
        },
        {
          title: t('__common.__mode'),
          key: "mode2",
          customRender: "modeColData",
          sort: true,
        },
        {
          title: t('__g3p_m8t.__dynamicRange'),
          key: "color_range",
          sort: true,
        },
        {
          title: t('__d4e_m8t.__profileName'),
          key: "profile_name",
          clickPopUp: 'profile_name_detail', //可以點擊出現選單，參數請設定需要被綁進Popup的key值
          clickPopUpIcon: 'asus_proart_sw_ico_arrow_s3', //此為default
          sort: true,
        },
        {
          title: t('__g3p_m8t.__implementationStatusSuccessFailWaitingForApply'),
          key: "newStatus",
          color: true,
          customRender: "twoTypeTableData",
          colorEnum: { //顏色設定
            999: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
            4: CONNECTION[1],
            666: CONNECTION[0],
          },
          isI18n: {
            999: '__common.__fail',
            1: '__common.__success',
            2: '__d7d_n17r.__waitingForReply',
            4: '__common.__successDeleted',
            666: '',
          },
          width: '25%',
        },
        // {
        //   title: t('__g3p_m8t.__implementationStatusSuccessFailWaitingForApply'),
        //   key: "implementationStatus",
        //   width: '30%',
        //   isLink: true,
        // },
        {
          title: t('__d4e_m8t.__report'),
          customRender: "report", //客製化slot，可用於外接其他組件
          key: "report",
        },
      ]

    })


    const appListColSub = computed(() => {
      return {
        calibrator: t('__d4e_m8t.__calibratorType'),
        presetMode: t('__d4e_m8t.__presetMode', {brand: brand.value}),
        gamut: t('__c3d_t4t.__colorGamut'),
        color_range: t('__g3p_m8t.__dynamicRange'),
        brightness: t('__d4e_m8t.__brightness'),
        gamma: t('__c3d_t4t.__gamma'),
        color_temperature: t('__d4e_m8t.__colorTemperature'),
        coordinate: t('__d4e_m8t.__coordinate'),
        eotf: t('__d4e_m8t.__eotf'),
      }
    })

    const appList2col = computed(() => {
      return [
        {
          title: t('__d4e_m8t.__brightness'),
          key: "brightness",
        },
        {
          title: t('__d4e_m8t.__colorTemperature'),
          key: "colorTemperature"
        },
        {
          title: t('__g3p_m8t.__dynamicRange'),
          key: "dynamicRang",
        },
        {
          title: t('__d4e_m8t.__calibratorType'),
          key: "calibratorType"
        },
        {
          title: t('__c3d_t4t.__colorGamut'),
          key: "gamuts",
        }
      ]
    })


    const modalColumn2 = computed(() => {//depiction_code
      // let
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "ssn",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "host",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "device_status",
          color: true,
          colorEnum:
          {
            0: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
          },
          isI18n:
          {
            0: '__g3p_m8t.__offline',
            1: '__g3p_m8t.__online',
            2: '__g3p_m8t.__waiting',
          },
          sort: true,
        },
        {
          title: t('__d4e_m8t.__implementationStatus'),
          key: "newStatus",
          color: true,
          colorEnum: //顏色設定
          {
            999: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
            4: CONNECTION[1],
          },
          isI18n:
          {
            999: '__common.__fail',
            1: '__common.__success',
            2: '__d7d_n17r.__waitingForReply',
            4: '__common.__successDeleted',
          },
          sort: true,
        },
        {
          title: t('__d4e_m8t.__report'),
          key: "report",
          customRender: "report",
        }
      ]
    })

    const opDLList = computed(() => {
      return [
        {
          text: t('__common.__all'),
          val: '',
          isI18n: '__common.__all',
        },
        {
          text: t('__d7d_n17r.__connectionStatus'),
          val: 'connection',
          isI18n: '__d7d_n17r.__connectionStatus',
          sub: [
            {
              text: t('__g3p_m8t.__online'),
              val: '1',
              isI18n: '__g3p_m8t.__online',
            },
            {
              text: t('__g3p_m8t.__offline'),
              val: '0',
              isI18n: '__g3p_m8t.__offline',
            }
          ]
        },
      ]
    })










    //UX行為

    const changeDatePicker = (e) => {
      console.log('changeDatePicker', e)
      state.implementDate = e;
    }

    const onClickTab = (v) => {
      let fullPath = route.currentRoute.value.fullPath.split("/")
      let path = fullPath.filter((element, index) => index < fullPath.length - 1).join('/');
      route.push(`${path}/${v.item.val}`);
    }

    const goTableLink = (v) => {
      // console.log( 'table link v.col', v.col)
      if(v.col['key'] == 'groupOrSsn'){
        let destination = '';
        if(v.val['group_name']){
          for (let i = 0; i < state.groupOption.length; i++) {
            if (state.groupOption[i].text == v.val.group_name) {
              destination = state.groupOption[i].val;
              route.push(`/main/group/${destination}/${ACTIONBAR.DEVICELIST}`);
            }
          }
        }else{
          destination = v.val['ssn'];
          route.push(`/main/device/${destination}/${ACTIONBAR.VIEWHIS}`);
        }
      }else if(v.col['key'] == 'implementationStatus'){
        // console.log( 'table link', v, state.groupOption)
        clickTasksStatus(v, false)
      }
      
    }



    //目前用不到
    const selectChange = () => {
    }

    const changePage = (page) => {
      if (page == state.meta.current) return
      state.meta.current = page;
      state.defaultCheckIndexList = [];

      apiPost()
    }
    const onCheckAll = (v) => {
      // console.log(v, 'table onCheck All')
      state.defaultCheckIndexList = [];
      state.list = v;
      v.forEach(itm => state.defaultCheckIndexList.push(itm.tableId));
    }

    const onCheckEach = (v) => {
      // console.log(state.list, 'table onCheck Each')
      state.defaultCheckIndexList = [];
      state.list = v;
      v.forEach(itm => state.defaultCheckIndexList.push(itm.tableId));
    }

    const showCTAndRow = (v) => {
      console.log(v, 'show ??? ContextMenu')
    }


    
    //table action end


    const tableSort = (v) => {
      console.log(v, 'sort table')
      state.order = v.val === 'up' ? 'asc' : 'desc';
      state.sort = v.key;
      // console.log('state.sort', state.sort)
      state.defaultCheckIndexList = [];
      apiPost()
    }

    const popupTest = () => {
      const modalConfig = {
        type: POPUP.DEVICENOTIFICATION,
        data: {
        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
      // apiPost() //重新取得裝置無連線的狀態
    }



    const editApp = async (e) => {
      route.push(`/main/calibration/modify/device/taskManagement/${e.id}`);
    }

    const goFilter = async () => {
      let flag = true;
      switch (state.isTabShow) {
        case TASKTAB.EXECUTED:
          if (!state.selectGroup.length || !state.selectModel.length || !state.selectImStatus.length) {
            flag = false;
            state.exeListData = []
          }
          break;
        case TASKTAB.APPOINTMENT:
          if (!state.selectGroup.length || !state.selectModel) {
            flag = false;
            state.appListData = []
          }
          break;
      }
      if (flag) apiPost()
    }

    const deleteFilter = async () => {
      resetFilterInit()
    }


    const report = (i) => {
      if (i.report) {
        window.open(i.report)
      }
    }










    const store = useStore()
    const brand = computed(() => store.state.brand);
    // const storeState = store.state;

    // store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
    //   // modal type
    //   // if (oldType === POPUP.DEVICERSET) {

    //   // } 
    // })

    const transferDepictionCode = (errorcode,valText) => {
      if(errorcode[valText]){
        return t(errorcode[valText])
      }else{
        return t(errorcode[100])
      }
      
    }




    return {
      state,
      deviceDetailPage,
      t,
      tabText,
      appListCol,
      exeListCol,
      ERRORDESC,
      popupTest,
      deleteET,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      changePage,
      onClickTab,
      selectChange,
      changeDatePicker,
      getTasks,
      getSetting,
      getAPData,
      presetTarget,
      setRepeat,
      isSpecificCalibrator,
      setAppListColSub,
      deleteAP,
      showCTAndRow,
      appList2col,
      editApp,
      goFilter,
      deleteFilter,
      caulDateTimeStamp,
      timeInit,
      report,
      clickTasksStatus,
      transferDepictionCode,
      setRepeatCol,
      modeCol
    }
  }// end: setup

}



